module.exports = __webpack_public_path__ + "img/shipping_type_3.7321886.png";